<template>
  <ul class="nav-list">
    <!-- Интеграции -->
    <IntegrationsItem
      :collapsed="collapsed"
      :active-item="activeItem"
      :can-see-page="canSeePage"
      @navigate="forwardNavigate"
      @middle-click="forwardMiddleClick"
      @context-menu="forwardContextMenu"
    />

    <!-- Журнал событий -->
    <ActivityLogItem
      :collapsed="collapsed"
      :active-item="activeItem"
      :can-see-page="canSeePage"
      @navigate="forwardNavigate"
      @middle-click="forwardMiddleClick"
      @context-menu="forwardContextMenu"
    />

    <!-- Настройки -->
    <SettingsItem
      :collapsed="collapsed"
      :active-item="activeItem"
      :can-see-page="canSeePage"
      @navigate="forwardNavigate"
      @middle-click="forwardMiddleClick"
      @context-menu="forwardContextMenu"
    />
  </ul>
</template>

<script>
import ActivityLogItem from "@/components/AppSidebar/items/ActivityLogItem.vue";
import IntegrationsItem from "@/components/AppSidebar/items/IntegrationsItem.vue";
import SettingsItem from "@/components/AppSidebar/items/SettingsItem.vue";

export default {
  name: "AppSidebarFooterItems",
  components: {
    ActivityLogItem,
    IntegrationsItem,
    SettingsItem,
  },
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
    activeItem: {
      type: String,
      required: true,
    },
    canSeePage: {
      type: Function,
      required: true,
    },
  },
  emits: ["navigate", "middle-click", "context-menu"],
  methods: {
    forwardNavigate(event, routeName) {
      this.$emit("navigate", event, routeName);
    },

    forwardMiddleClick(event, routeName) {
      this.$emit("middle-click", event, routeName);
    },

    forwardContextMenu(event, routeName) {
      this.$emit("context-menu", event, routeName);
    },
  },
};
</script>
